(() => {
  const remaining = (end,now=Date.now()) => {
    const deadline=Date.parse(end);
    if(!Number.isFinite(deadline))return null;
    const total=Math.max(0,Math.ceil((deadline-now)/1000));
    return {total,days:Math.floor(total/86400),hours:Math.floor(total%86400/3600),minutes:Math.floor(total%3600/60),seconds:total%60};
  };
  if(typeof module!=='undefined'&&module.exports)module.exports={remaining};
  if(typeof window==='undefined'||customElements.get('rc-black-weeks-countdown'))return;
  customElements.define('rc-black-weeks-countdown',class extends HTMLElement{
    connectedCallback(){
      this.lastMinute=-1;
      const deadlineLabel=this.closest('[data-bw-offer-clock]')?.querySelector('[data-bw-end-label]');
      if(deadlineLabel&&Number.isFinite(Date.parse(this.dataset.end))){
        const date=new Date(this.dataset.end);
        const day=new Intl.DateTimeFormat('pl-PL',{timeZone:'Europe/Warsaw',day:'2-digit',month:'2-digit'}).format(date);
        const hour=new Intl.DateTimeFormat('pl-PL',{timeZone:'Europe/Warsaw',hour:'2-digit',minute:'2-digit',hour12:false}).format(date);
        deadlineLabel.textContent=day+' · godz. '+hour;
      }
      this.tick=()=>{
        clearTimeout(this.timer);
        const time=remaining(this.dataset.end);
        if(!time){this.hidden=true;return;}
        ['days','hours','minutes','seconds'].forEach(key=>{const node=this.querySelector('[data-bw-'+key+']');if(node)node.textContent=String(time[key]).padStart(2,'0');});
        if(Math.floor(time.total/60)!==this.lastMinute){
          this.lastMinute=Math.floor(time.total/60);
          this.querySelector('[data-bw-accessible]').textContent='Do końca akcji: '+time.days+' dni, '+time.hours+' godzin i '+time.minutes+' minut.';
        }
        if(time.total===0){
          const strip=this.closest('[data-bw-strip]');if(strip)strip.hidden=true;
          const caption=this.closest('[data-bw-offer-clock]')?.querySelector('.bw-clock-caption');if(caption)caption.textContent='Akcja zakończona';
          if(!this.ended){this.ended=true;document.dispatchEvent(new CustomEvent('blackweeks:ended'));}
          return;
        }
        this.timer=setTimeout(this.tick,1000-Date.now()%1000+20);
      };
      this.visibility=()=>{if(!document.hidden)this.tick();else clearTimeout(this.timer);};
      document.addEventListener('visibilitychange',this.visibility);this.tick();
    }
    disconnectedCallback(){clearTimeout(this.timer);document.removeEventListener('visibilitychange',this.visibility);}
  });
})();